// Configuración de métodos de pago habilitados/deshabilitados
const paymentMethods = {
  visa: true,
  mastercard: false,
  webpay: false,
  getnet: true,
  khipu: false,
  transferencia: false,
};

export default paymentMethods;
